
define('text!core/partials/Error-503-serviceUnavailableContent.html',[],function () { return '<div class="defaultDataUnavailableBlock error">\n    <span class="icon iconWarning">{{\'core.featureUnavailable.widgetText\'|i18n}}</span>\n</div>';});

